import { useGetOrganisationUsers } from 'hooks/useGetOrganisationUsers';
import { useGetDocument } from 'pages/documents_v2/hooks/useGetDocument';
import HelperFunctions from 'pages/global/HelperFunctions';
import { useMemo } from 'react';

const emptyArray = [];

/**
 * @param {number} [documentId]
 *
 * @returns {import('models/documents.models').DocumentUser[]}
 */
export function useGetDocumentUsers(documentId) {
    const users = useGetOrganisationUsers(true);
    const document = useGetDocument(documentId);

    // Create a map of users for O(1) lookup by user id.
    const usersById = useMemo(() => new Map(users.map((user) => [user.id, user])), [users]);

    // Memoise the enriched and sorted document users.
    return useMemo(() => {
        if (!document) {
            return emptyArray;
        }

        return document.documentUsers
            .map((documentUser) => {
                const user = usersById.get(documentUser.userId);
                return {
                    ...documentUser,
                    user,
                    fullName: user?.fullName,
                };
            })
            .filter((documentUser) => documentUser.user)
            .sort(HelperFunctions.sortByString('fullName'));
    }, [document, usersById]);
}
